import { setLoading } from "redux/actions/app.actions";
import { request } from "./verb.services";
import { openNotificationWithIcon } from "utils/Notification";
import {
  GIFTCARD_CONFIG_KEY,
  PROMO_GIFTCARD_CONFIG_KEY,
} from "utils/constants";
import { getServerErrorString } from "utils/common";

export const updateGiftCard = (giftCardId, data, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`GiftCards/${giftCardId}`, "patch", data, true)
      .then(() => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Gift Card updated successfully"
        );
        callback?.();
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const getGiftCardById = (giftCardId, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`GiftCards/${giftCardId}`, "get", null, true)
      .then((res) => {
        return { status: "success", data: res.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

/**
 * @param {number} customerId  - id of the customer
 * */
export const getCustomerGiftCards = (customerId, callback) => {
  return (dispatch) => {
    return request(
      `GiftCards?customerId=${customerId}`,
      "get",
      null,
      true,
      null
    )
      .then((result) => {
        callback?.(result?.data);
        return {
          status: "success",
          data: result.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.message || e?.message || "Something went wrong"
        );
      })
      .finally(() => {});
  };
};

export const purchaseGiftCard = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Orders/GiftCard`, "post", data, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Gift Card Purchased",
          "Your gift card has been purchased successfully."
        );
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
        return {
          status: "error",
          message: e?.response?.data?.message || "Network error has occured",
        };
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const redeemGiftCard = (giftCardId) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`GiftCards/${giftCardId}/Redeem`, "post", {}, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Gift Card Redeemed",
          "Your gift card has been redeemed successfully."
        );
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
        return {
          status: "error",
          message: e?.response?.data?.message || "Network error has occured",
        };
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const getGiftCardDesign = (loading, callback) => {
  return (dispatch) => {
    if (loading) dispatch(setLoading(true));
    return request(
      `Configurations/${GIFTCARD_CONFIG_KEY}`,
      "get",
      null,
      true,
      null
    )
      .then((res) => {
        let designValues = {};
        if (res?.data) {
          designValues = JSON.parse(decodeURI(res?.data?.value || "{}"));
        }
        return { status: "success", data: designValues };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        if (loading) dispatch(setLoading(false));
      });
  };
};

export const getPromoGiftCardDesign = (loading, callback) => {
  return (dispatch) => {
    if (loading) dispatch(setLoading(true));
    return request(
      `Configurations/${PROMO_GIFTCARD_CONFIG_KEY}`,
      "get",
      null,
      true,
      null
    )
      .then((res) => {
        let designValues = {};
        if (res?.data) {
          designValues = JSON.parse(decodeURI(res?.data?.value || "{}"));
        }
        return { status: "success", data: designValues };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        if (loading) dispatch(setLoading(false));
      });
  };
};

// get giftcards list
export const getFilteredGiftcards = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Giftcards/Filter`, "post", data, true)
      .then((res) => {
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
        return {
          status: "error",
          message: e?.response?.data?.message || "Network error has occured",
        };
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const resendGiftcardInvitation = (giftCardId, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `GiftCards/${giftCardId}/ResendInvitition`,
      "patch",
      {},
      true
    )
      .then(() => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Gift Card invitation sent successfully"
        );
        callback?.();
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
